"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _root_store = _interopRequireDefault(require("./root_store"));
var _class;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DiscordRoleStore = (_class = /*#__PURE__*/function (_RootStore) {
  function DiscordRoleStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, DiscordRoleStore);
    _this = _callSuper(this, DiscordRoleStore);
    _this.config = {
      GET: {
        index: '/discord_roles'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(DiscordRoleStore, _RootStore);
  return (0, _createClass2["default"])(DiscordRoleStore, [{
    key: "optionsForSelect",
    get: function get() {
      return this.indexData.map(function (_ref) {
        var id = _ref.id,
          name = _ref.name;
        return [id, name];
      });
    }
  }]);
}(_root_store["default"]), (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "optionsForSelect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "optionsForSelect"), _class.prototype), _class);
var _default = exports["default"] = new DiscordRoleStore();